import p from "./fixed-footer-layout.js";
import d from "./button-layout.js";
import { useScreenSize as c } from "./hooks.js";
import h from "./responsive-layout.js";
import x from "./box.js";
import { jsx as o, jsxs as F } from "./_virtual/jsx-runtime.js";
const T = (param)=>{
    let { isFooterVisible: i = !0 , button: t , secondaryButton: r , link: s , children: l , desktopButtonAlign: m = "left" , footerBgColor: a , containerBgColor: n , onChangeFooterHeight: u  } = param;
    const { isTabletOrSmaller: e , isTablet: f  } = c();
    return /* @__PURE__ */ o(p, {
        onChangeFooterHeight: u,
        isFooterVisible: (!!t || !!r) && i,
        footerBgColor: a,
        containerBgColor: n,
        footer: /* @__PURE__ */ o(h, {
            children: /* @__PURE__ */ o(x, {
                paddingY: f ? 32 : e ? 16 : 0,
                children: /* @__PURE__ */ F(d, {
                    align: e ? "full-width" : m,
                    link: s,
                    children: [
                        t,
                        r
                    ]
                })
            })
        }),
        children: l
    });
};
export { T as default };
